import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import Navbar from "../nav_bar/Navbar";
import axiosInstance from "../../api/axiosInstance";
import "./Support.css";

const TicketDetail = () => {
  const { ticketId } = useParams();

  // ✅ Logged-in user
  const storedUser = localStorage.getItem("user");
  const user = storedUser ? JSON.parse(storedUser) : null;
  const userId = user?.userId;


  const [ticket, setTicket] = useState(null);
  const [loading, setLoading] = useState(true);

  const [replyMessage, setReplyMessage] = useState("");
  const [sending, setSending] = useState(false);
  const [error, setError] = useState("");

  // ✅ Ref to scroll conversation
  const conversationRef = useRef(null);

  const fetchTicket = async () => {
    try {
      const res = await axiosInstance.get(`/client/support/${ticketId}`);

      setTicket(res.data);

      // Scroll to bottom after fetch
      setTimeout(() => {
        conversationRef.current?.scrollTo({
          top: conversationRef.current.scrollHeight,
          behavior: "smooth",
        });
      }, 50);
    } catch (err) {
    
      setError("Failed to load ticket details.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTicket();
  }, [ticketId]);

  // 🔍 LOGS: Ticket state updates
  useEffect(() => {

  }, [ticket]);

  const handleReplySubmit = async () => {
    if (!replyMessage.trim()) return;

    if (!userId) {
      setError("User not logged in.");
      return;
    }

    setSending(true);
    setError("");

    try {
      await axiosInstance.post(
        `/client/support/${ticketId}/reply?userId=${userId}`,
        replyMessage,
        {
          headers: {
            "Content-Type": "text/plain",
          },
        }
      );


      setReplyMessage("");
      fetchTicket(); // refresh conversation
    } catch (err) {
      setError("Failed to send reply. Please try again.");
    } finally {
      setSending(false);
    }
  };

  return (
    <>
      <Navbar />

      <div className="support-page">
        <div className="support-container">
          {loading ? (
            <p className="support-subtitle">Loading ticket...</p>
          ) : !ticket ? (
            <p className="support-subtitle">Ticket not found.</p>
          ) : (
            <div className="support-card">
              <h2 className="support-title">{ticket.subject}</h2>

              <div className="ticket-meta">
                <span className={`ticket-status ${ticket.status?.toLowerCase()}`}>
                  {ticket.status}
                </span>
                <span>{new Date(ticket.createdAt).toLocaleString()}</span>
              </div>

              {/* Conversation */}
              <div className="conversation" ref={conversationRef}>
                {/* Initial ticket message (USER) */}
                <div className="message-user">
                  <div className="message-label">You</div>
                  <div className="message-bubble">{ticket.message}</div>
                  <div className="ticket-date">
                    {new Date(ticket.createdAt).toLocaleString()}
                  </div>
                </div>

                {/* Replies */}
                {ticket.replies &&
                  ticket.replies.map((reply, index) => {
                    const isAdmin = reply.senderType === "ADMIN";

                    return (
                      <div
                        key={index}
                        className={isAdmin ? "message-admin" : "message-user"}
                      >
                        <div className="message-label">
                          {isAdmin ? "Support" : "You"}
                        </div>

                        <div className="message-bubble">
                          {reply.message}
                        </div>

                        <div className="ticket-date">
                          {new Date(reply.createdAt).toLocaleString()}
                        </div>
                      </div>
                    );
                  })}
              </div>

              {/* Error */}
              {error && <p className="support-error">{error}</p>}

              {/* Reply box */}
              <div className="reply-box">
                <textarea
                  rows="3"
                  placeholder="Type your response..."
                  value={replyMessage}
                  onChange={(e) => setReplyMessage(e.target.value)}
                  disabled={sending}
                />

                <button
                  className="support-button"
                  onClick={handleReplySubmit}
                  disabled={sending}
                  style={{ background: "var(--brand-color, #007bff)" }}
                >
                  {sending ? "Sending..." : "Send Reply"}
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default TicketDetail;
